import type { CustomerTier } from '@/api/client'
import { cn } from '@/lib/cn'
import { Award } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  tier: CustomerTier
  className?: string
  showIcon?: boolean
}

const styles: Record<CustomerTier, string> = {
  gold: 'bg-amber-50 text-amber-800 ring-1 ring-inset ring-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:ring-amber-900/60',
  silver:
    'bg-muted text-foreground ring-1 ring-inset ring-ring',
  bronze:
    'bg-orange-50 text-orange-800 ring-1 ring-inset ring-orange-200 dark:bg-orange-950/40 dark:text-orange-300 dark:ring-orange-900/60',
}

const iconColors: Record<CustomerTier, string> = {
  gold: 'text-amber-500',
  silver: 'text-muted-foreground',
  bronze: 'text-orange-500',
}

export function TierBadge({ tier, className, showIcon = true }: Props) {
  const { t } = useTranslation('common')
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium capitalize',
        styles[tier],
        className,
      )}
    >
      {showIcon ? <Award className={cn('h-3 w-3', iconColors[tier])} aria-hidden="true" /> : null}
      {t(`customers.tier.${tier}`, { defaultValue: tier })}
    </span>
  )
}
